// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".captcha[data-v-cd94e8f4]{cursor:pointer;display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
